import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faShoppingCart,
    faWeightHanging,
    faBoxes,
    faClock,
    faCheckCircle,
} from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

const PurchaseOverview = ({ data }) => {
    const { t } = useTranslation();
    if (!data) return null;
    const strings = t('purchaseAnalytics.overview', { returnObjects: true });

    const sections = [
        {
            title: t('commonCols.purchaseSummary'),
            color: '#0891b2',
            bg: '#ecfeff',
            border: '#a5f3fc',
            cards: [
                {
                    label: strings.totalOrders,
                    value: data.total_orders ?? 0,
                    icon: faShoppingCart,
                    sub: 'All orders',
                },
                {
                    label: strings.totalWeightTons,
                    value: `${parseFloat(data.total_weight_tons || 0).toFixed(3)} T`,
                    icon: faWeightHanging,
                    sub: 'Metric tons',
                },
                {
                    label: strings.totalQuantity,
                    value: parseFloat(data.total_quantity || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 }),
                    icon: faBoxes,
                    sub: 'Units',
                },
            ],
        },
        {
            title: t('commonCols.orderStatus'),
            color: '#d97706',
            bg: '#fffbeb',
            border: '#fde68a',
            cards: [
                {
                    label: strings.pendingOrders,
                    value: data.pending_orders ?? 0,
                    icon: faClock,
                    sub: 'Awaiting receipt',
                },
                {
                    label: strings.receivedOrders,
                    value: data.received_orders ?? 0,
                    icon: faCheckCircle,
                    sub: 'Completed',
                },
            ],
        },
    ];

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
            {sections.map(section => (
                <div key={section.title}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
                        <div style={{ width: 3, height: 16, borderRadius: 2, backgroundColor: section.color }} />
                        <span style={{ fontSize: 12, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.6px' }}>
                            {section.title}
                        </span>
                    </div>
                    <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                        {section.cards.map(card => (
                            <div
                                key={card.label}
                                style={{
                                    flex: '1 1 160px',
                                    minWidth: 160,
                                    maxWidth: 260,
                                    backgroundColor: '#ffffff',
                                    border: `1px solid ${section.border}`,
                                    borderRadius: 12,
                                    padding: '14px 16px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 6,
                                    transition: 'box-shadow 0.15s',
                                    cursor: 'default',
                                }}
                                onMouseEnter={e => e.currentTarget.style.boxShadow = `0 4px 16px ${section.border}99`}
                                onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}
                            >
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                    <span style={{ fontSize: 11.5, fontWeight: 600, color: '#111827', textTransform: 'uppercase', letterSpacing: '0.4px', lineHeight: 1.3 }}>
                                        {card.label}
                                    </span>
                                    <div style={{
                                        width: 30, height: 30, borderRadius: 8,
                                        backgroundColor: section.bg,
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        color: section.color, fontSize: 13, flexShrink: 0, marginLeft: 6,
                                    }}>
                                        <FontAwesomeIcon icon={card.icon} />
                                    </div>
                                </div>
                                <div style={{ fontSize: 22, fontWeight: 800, color: '#111827', lineHeight: 1 }}>
                                    {card.value}
                                </div>
                                <div style={{ fontSize: 11, color: '#9ca3af' }}>{card.sub}</div>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default PurchaseOverview;
